// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".product-carousel-section{overflow:hidden;padding-top:50px;padding-bottom:50px}@media (min-width: 1050px){.product-carousel-section{padding-top:75px;padding-bottom:75px}}.product-card{box-shadow:0 2px 40px -8px rgba(182,182,182,0.5)}.product-card .product-card-title{font-size:16px}@media (min-width: 1050px){.product-card .product-card-title{font-size:20px}}\n", ""]);
// Exports
module.exports = exports;
